import React from "react";
import OrderConfirmationSummary from "../order-summary/OrderConfirmationSummary";

const CheckoutConfirmForm = ({ addons, pageContext, currentTab, setCurrentTab, orderNumber, totalPrice }) => {
	return (
		<OrderConfirmationSummary
			addons={addons}
			pageContext={pageContext}
			currentTab={currentTab}
			setCurrentTab={setCurrentTab}
			orderNumber={orderNumber}
			totalPrice={totalPrice}
		/>
	);
};

export default CheckoutConfirmForm;
